import { ColorModeContext, useMode } from "./Theme/theme";
import { CssBaseline, ThemeProvider } from "@mui/material";
import Topbar from "./components/global/Topbar";
import { Route, Routes } from "react-router-dom";
import Dashboard from "./components/Dashborad/Dashboard";
import Sidebar from "./components/global/Sidebar";
import Users from "./components/Users/Users";
import BarChart from "./components/Charts/BarChart";
import PieChart from "./components/Charts/PieChart";
import EnabledLocations from "./components/EnabledLocations/EnabledLocations";
import IndividualEnabledLocationDetails from "./components/EnabledLocations/IndividualEnabledLocationDetails";
import LiveUsers from "./components/Live Users/LiveUsers";
import AdminList from "./components/AdminRoles/AdminList";
import AddAdminModal from "./components/AdminRoles/AddAdminModal";
import ParticularUserInfo from "./components/Users/ParticularUserInfo";
import ChatsAndMatches from "./components/ChatsAndMatches/ChatsAndMatches";
import AddEnabledLocation from "./components/EnabledLocations/AddEnabledLocation";
import AddAdmins from "./components/AdminRoles/AddAdmins";
import Login from "./components/Login/Login";
import { Admin } from "./components/Admin";
import ActiveUser from "./components/ActiveUsers/ActiveUser";
import SendNotification from "./components/Notification/SendNotification";
import Chirps from "./components/Chirps/Chirps";
import IndividualChirps from "./components/Chirps/IndividualChirps";
import EditEnabledLocationDetails from "./components/EnabledLocations/EditEnabledLocation/EditEnabledLocationDetails";
import AddNewImages from "./components/EnabledLocations/EditEnabledLocation/AddNewImages";
import LiveCount from "./components/LiveCount/LiveCount";
import CommunityList from "./components/Community/CommunityList";
import CommunityDetail from "./components/Community/CommunityDetail";
import CommunityMembers from "./components/Community/CommunityMembers";
import CommunityUserActivity from "./components/Community/CommunityUserActivity";
import CommunityRedirect from "./components/Community/CommunityRedirect";
import ReferralScreen from "./components/Referral/ReferralScreen";
import QRScan from "./components/Referral/QRScanner";
import UserContent from "./components/Moderation/UserContent";
import ShortLinks from "./components/LinkShortner/ShortLinks";
import SubscriptionCommunities from "./components/Subscriptions/SubscriptionCommunities";
import SubscriptionDetails from "./components/Subscriptions/SubscriptionDetails";
import EventsListScreen from "./components/Events/EventsListScreen";
import EventDetailScreen from "./components/Events/EventDetailScreen";
import NoticeboardDetails from "./components/Community/NoticeboardDetails";
import SpacesList from "./components/Spaces/SpacesList";
import SpaceDetail from "./components/Spaces/SpaceDetail";
import ProfileScreen from "./components/Dashborad/ProfileScreen";
import JobsListScreen from "./components/Jobs/JobsListScreen";
import JobDetailScreen from "./components/Jobs/JobDetailScreen";
import CreatePostScreen from "./components/Moderation/CreatePostScreen";
import ClubsListScreen from "./components/Club/ClubsListScreen";
import ClubDetailScreen from "./components/Club/ClubDetailScreen";


function App() {
  const [theme, colorMode] = useMode();
  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />

        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="admin" element={<Admin />}>
            <Route path="users" element={<Users />} />
            <Route path="profile" element={<ProfileScreen />} />
            <Route path="user-content" element={<UserContent />} />
            <Route path="new-post" element={<CreatePostScreen />} />
            <Route path="scan-and-validate" element={<QRScan />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="events" element={<EventsListScreen />} />
            <Route path="jobs" element={<JobsListScreen />} />
            <Route path="clubs" element={<ClubsListScreen />} />
            <Route path="club-dt" element={<ClubDetailScreen />} />
            <Route path="event-details" element={<EventDetailScreen />} />
            <Route path="job-details" element={<JobDetailScreen />} />
            <Route path="referrals" element={<ReferralScreen />} />
            <Route path="enabledlocations" element={<EnabledLocations />} />
            <Route path="enabledlocationdetails" element={<IndividualEnabledLocationDetails />} />
            <Route path="liveusers" element={<LiveUsers />} />
            <Route path="adminlist" element={<AdminList />} />
            <Route path="particularuserdetails" element={<ParticularUserInfo />} />
            <Route path="chatsandmatches" element={<ChatsAndMatches />} />
            <Route path="addenabledlocation" element={<AddEnabledLocation />} />
            <Route path="addadmins" element={<AddAdmins />} />
            <Route path="activeusers" element={<ActiveUser />} />
            <Route path="notify" element={<SendNotification />} />
            <Route path="subscriptions" element={<SubscriptionCommunities />} />
            <Route path="subscription-details" element={<SubscriptionDetails />} />
            <Route path="sm-links" element={<ShortLinks />} />
            <Route path="chirps" element={<Chirps />} />
            <Route path="particularchirpdetails" element={<IndividualChirps />} />
            <Route path="editenabledlocationdetails" element={<EditEnabledLocationDetails />} />
            <Route path="addnewimageforalocation" element={<AddNewImages />} />
            <Route path="livedata" element={<LiveCount />} />
            <Route path="communities" element={<CommunityList />} />
            <Route path="spaces" element={<SpacesList />} />
            <Route path="noticeboard" element={<NoticeboardDetails />} />
            <Route path="communitydetail" element={<CommunityDetail />} />
            <Route path="space-dt" element={<SpaceDetail />} />
            <Route path="communitymembers" element={<CommunityMembers />} />
            <Route path="community/user/activity" element={<CommunityUserActivity />} />
          </Route>
        </Routes>

      </ThemeProvider>
    </ColorModeContext.Provider >
  );
}

export default App;
